import { Injectable } from "@angular/core";
import { GridifyQueryBuilder, IGridifyQuery } from "gridify-client";
import { HttpParams } from "@angular/common/http";
import { GridfyFilter } from "../models/gridfy-filter";

@Injectable({
  providedIn: 'root'
})
export class QueryFilterService {
  constructor() {
  }

  public getQueryBuilder(): GridifyQueryBuilder {
    const defaultQueryFilter = new GridifyQueryBuilder().setPage(1).setPageSize(500);

    return new GridifyQueryBuilder({ allowEmptyGroups: true, from: defaultQueryFilter });
  }

  public getQueryParams(queryFilter: IGridifyQuery | null = null): HttpParams {
    if (!queryFilter) {
      return new HttpParams();
    }

    const params = {};

    for (const [key, value] of Object.entries(queryFilter)) {
      if (value !== undefined && value !== null && value !== "") {
        params[key] = value;
      }
    }

    return new HttpParams({ fromObject: params });
  }

  applyFilters(queryFilter: GridifyQueryBuilder, filters: GridfyFilter[]) {
    let hasConditions = false;

    for (const filter of filters) {

      if (hasConditions) {
        queryFilter.and();
      }

      queryFilter.addCondition(filter.field, filter.operator, filter.value);
      hasConditions = true;
    }
  }
}
